import React from 'react';
import { Button } from '../ui/button';

interface ProjectSettingsModalProps {
  show: boolean;
  selectedDocument: any;
  category: string;
  dueDate: string;
  numberOfStories: string;
  completed: string;
  onChange: (field: string, value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onClose: () => void;
}

const ProjectSettingsModal: React.FC<ProjectSettingsModalProps> = ({
  show,
  selectedDocument,
  category,
  dueDate,
  numberOfStories,
  completed,
  onChange,
  onSubmit,
  onClose
}) => {
  if (!show || !selectedDocument) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full relative">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-600 hover:text-black">&times;</button>
        <h2 className="text-lg font-bold mb-4">Project Settings</h2>
        <div className="mb-4"><span className="font-semibold">Document:</span> {selectedDocument.fileName}</div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Category</label>
            <input type="text" className="w-full border rounded px-2 py-1" value={category} onChange={e => onChange('category', e.target.value)} required />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Due Date</label>
            <input type="date" className="w-full border rounded px-2 py-1" value={dueDate} onChange={e => onChange('dueDate', e.target.value)} required />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Number of Stories</label>
            <input type="number" className="w-full border rounded px-2 py-1" value={numberOfStories} onChange={e => onChange('numberOfStories', e.target.value)} required min="1" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Completed Stories</label>
            <input type="number" className="w-full border rounded px-2 py-1" value={completed} onChange={e => onChange('completed', e.target.value)} required min="0" max={numberOfStories ? Number(numberOfStories) : undefined} />
          </div>
          <div className="flex justify-end">
            <Button type="submit" className="bg-custom-blue-600 hover:bg-custom-blue-700 text-white">Save Project</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProjectSettingsModal;
